import { AddHandlePlusIcon } from "./AddHandlePlusIcon";

/**
 * Visible "+" affordance rendered on each edge midpoint (and decision
 * true/false segments). Wrapped by EdgeAddButton in basehandle.styled.ts,
 * which sets the outer chrome (white circle, teal ring, hover halo) — this
 * component renders just the plus glyph inside.
 *
 * QA: previously returned null because the team experimented with putting
 * the add affordance only at node corners. Reviewers couldn't see how to
 * insert between two existing nodes, so the edge "+" is back.
 */
export function AddHandleChrome() {
	return <AddHandlePlusIcon size={14} />;
}
